/* eslint-disable */
import React, { useEffect } from "react";
import Header from "components/Common/Header/Header";
import WebsiteBuilderListBody from "components/WebsiteBuilderComponents/WebsiteBuilderListBody/WebsiteBuilderListBody";

const WebsiteBuilderList = () => {
  useEffect(() => {
    document.title = "Website Builder";
  }, []);

  return (
    <main id="app">
      <Header moduleName="websitebuilder" />
      <WebsiteBuilderListBody />
    </main>
  );
};

export default WebsiteBuilderList;
